




import Vue from "vue";

import moment from "moment-timezone";

import {
  PopoverMode,
  ContextMenuItem,
  ContextMenuItems,
} from "@/api/Termine";
import { Transaktion } from "@/api/Abrechnung";

export interface MenuItemSelected {
  popoverMode: PopoverMode;
  transaktion: Transaktion;
}

export default Vue.extend({
  name: "KassenbuchUebersichtContextMenu",
  data() {
    return {
      contextMenuEntries: [] as ContextMenuItems,
    };
  },
  methods: {
    open(transaktion?: Transaktion) {
      const fn = (action: PopoverMode) => {
        return ((originalEvent: Event, item: ContextMenuItem) =>
          this.onSelectContextmenu(
            originalEvent,
            action,
            transaktion
          )).bind(this);
      };

      this.contextMenuEntries = [
        {
          label: `Neue Ausgabe anlegen`,
          icon: "pi pi-fw pi-calendar-plus",
          command: fn("create"),
          visible: true,
        },
      ];

      if (transaktion) {
        // Kontextmenü eines Termines
        // TODO: Berechtigungen prüfen
        this.contextMenuEntries.push(
          {
            label: "Bearbeiten",
            icon: "pi pi-fw pi-pencil",
            command: fn("edit"),
            visible: true,
          },
          {
            label: "Duplizieren",
            icon: "pi pi-fw pi-copy",
            command: fn("duplicate"),
            visible: true,
          },
          {
            label: "Löschen",
            icon: "pi pi-fw pi-trash",
            command: fn("delete"),
            visible: true,
          },
        );
      }

      const contextMenu: any = this.$refs.contextMenu;
      contextMenu.show(event);
    },

    // Auswahl eines Kontextmenü-Eintrags
    onSelectContextmenu(
      event: any,
      action: string,
      transaktion?: Transaktion
    ) {
      console.log(event);
      console.log(action);
      console.log(transaktion);
      this.$emit("select", {
        popoverMode: action,
        transaktion,
      } as MenuItemSelected);
    },
  },
});
